export class CustomerInfo {
  clientLastname: string;
  clientFirstname: string;
  clientEmail: string;
  clientPhone: string;
  clientStreet: string;
  clientStreetMore?: string;
  clientZipCode: string;
  clientCity: string;
  clientCountry: string;

  constructor(
    clientLastname: string,
    clientFirstname: string,
    clientEmail: string,
    clientPhone: string,
    clientStreet: string,
    clientStreetMore: string | null = null,
    clientZipCode: string,
    clientCity: string,
    clientCountry: string
  ) {
    this.clientLastname = clientLastname;
    this.clientFirstname = clientFirstname;
    this.clientEmail = clientEmail;
    this.clientPhone = clientPhone;
    this.clientStreet = clientStreet;
    if (clientStreetMore !== null) {
      this.clientStreetMore = clientStreetMore;
    }
    this.clientZipCode = clientZipCode;
    this.clientCity = clientCity;
    this.clientCountry = clientCountry;
  }
}
